<template>
  <li class="d-flex align-items-center text-uppercase cursor-pointer">
    <Square
      :centered="true"
      class="deepify-dark-bg mr-3"
      style="min-width: 28px!important;"
    >
      <FontAwesome
        v-if="showIcon"
        icon="fas fa-arrows-alt-v"
      />
    </Square>
    <small>{{ item }}</small>
  </li>
</template>
<script>
import { ElementMixin } from 'vue-slicksort';
import Square from '@/components/core/Square.vue';

export default {
  components: {
    Square,
  },
  mixins: [
    ElementMixin,
  ],
  props: {
    item: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
